import './PeriscopeFieldGroup.scss';

import { PeriscopeFieldRow } from './PeriscopeFieldRow';
import { PeriscopeSfField } from '@sonar-software/sonar-ts-types';
import React from 'react';

export interface FieldGroup {
	name: string | null | undefined;
	fields: PeriscopeSfField[];
	showParents?: boolean;
}

export interface PeriscopeFieldGroupProps {
	group: FieldGroup;
	parentIndex: number;
	showParent?: boolean;
	source?: string;
	useApiNames: boolean;
}

export const PeriscopeFieldGroup: React.FC<PeriscopeFieldGroupProps> = ({ group, ...rest }) =>
	<div className='periscope-field-group'>
		<span>{ group.name }</span>
		<div className='periscope-field-list'>
			{ group.fields.map((field, index) =>
				<PeriscopeFieldRow
					field={ field }
					// eslint-disable-next-line react/no-array-index-key
					key={ `${field.sonarObjectId}-${index}` }
					{ ...rest } />) }
		</div>
	</div>;

